import { useRef, useEffect, useCallback } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Hook per la chiamata debounce di una funzione
 * @param callback
 * @param delay (milliseconds)
 * @param deps
 */
function useDebouncedFunc(callback, delay = 100, deps = []) {
    const latestCallback = useRef();
    const latestTimeout = useRef();
    useEffect(() => {
        latestCallback.current = callback;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callback, ...deps]);
    return useCallback((...args) => {
        if (latestTimeout.current) {
            clearTimeout(latestTimeout.current);
        }
        latestTimeout.current = setTimeout(() => { latestCallback.current(...args); }, delay);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [delay, ...deps]);
}

export { useDebouncedFunc as default };
